/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderAppMetadata } from './ProviderAppMetadata';
import {
    ProviderAppMetadataFromJSON,
    ProviderAppMetadataFromJSONTyped,
    ProviderAppMetadataToJSON,
} from './ProviderAppMetadata';

/**
 * The provider app fields to update. (Only include the fields you'd like to update.)
 * @export
 * @interface UpdateProviderAppRequestProviderApp
 */
export interface UpdateProviderAppRequestProviderApp {
    /**
     * The ID used by the provider to identify the app (optional).
     * @type {string}
     * @memberof UpdateProviderAppRequestProviderApp
     */
    externalRef?: string;
    /**
     * The SaaS provider that this app connects to.
     * @type {string}
     * @memberof UpdateProviderAppRequestProviderApp
     */
    provider?: string;
    /**
     * The OAuth client ID for this app.
     * @type {string}
     * @memberof UpdateProviderAppRequestProviderApp
     */
    clientId?: string;
    /**
     * The OAuth client secret for this app.
     * @type {string}
     * @memberof UpdateProviderAppRequestProviderApp
     */
    clientSecret?: string;
    /**
     * The OAuth scopes for this app.
     * @type {Array<string>}
     * @memberof UpdateProviderAppRequestProviderApp
     */
    scopes?: Array<string>;
    /**
     * 
     * @type {ProviderAppMetadata}
     * @memberof UpdateProviderAppRequestProviderApp
     */
    metadata?: ProviderAppMetadata;
}

/**
 * Check if a given object implements the UpdateProviderAppRequestProviderApp interface.
 */
export function instanceOfUpdateProviderAppRequestProviderApp(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateProviderAppRequestProviderAppFromJSON(json: any): UpdateProviderAppRequestProviderApp {
    return UpdateProviderAppRequestProviderAppFromJSONTyped(json, false);
}

export function UpdateProviderAppRequestProviderAppFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProviderAppRequestProviderApp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'externalRef': !exists(json, 'externalRef') ? undefined : json['externalRef'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'clientSecret': !exists(json, 'clientSecret') ? undefined : json['clientSecret'],
        'scopes': !exists(json, 'scopes') ? undefined : json['scopes'],
        'metadata': !exists(json, 'metadata') ? undefined : ProviderAppMetadataFromJSON(json['metadata']),
    };
}

export function UpdateProviderAppRequestProviderAppToJSON(value?: UpdateProviderAppRequestProviderApp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'externalRef': value.externalRef,
        'provider': value.provider,
        'clientId': value.clientId,
        'clientSecret': value.clientSecret,
        'scopes': value.scopes,
        'metadata': ProviderAppMetadataToJSON(value.metadata),
    };
}

